var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5H32C36.4183 0.5 40 4.08172 40 8.5V32.5C40 36.9183 36.4183 40.5 32 40.5H8C3.58172 40.5 0 36.9183 0 32.5V8.5Z",
    fill: "#0B141D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2425 16.2574C24.3832 16.398 24.4622 16.5888 24.4622 16.7877C24.4622 16.9866 24.3832 17.1774 24.2425 17.318L21.0606 20.5L24.2425 23.682C24.3832 23.8227 24.4622 24.0134 24.4622 24.2123C24.4622 24.4113 24.3832 24.602 24.2425 24.7427C24.1019 24.8833 23.9111 24.9623 23.7122 24.9623C23.5133 24.9623 23.3225 24.8833 23.1819 24.7427L19.9999 21.5607L16.8179 24.7427C16.6773 24.8833 16.4865 24.9623 16.2876 24.9623C16.0887 24.9623 15.8979 24.8833 15.7573 24.7427C15.6166 24.602 15.5376 24.4113 15.5376 24.2123C15.5376 24.0134 15.6166 23.8227 15.7573 23.682L18.9392 20.5L15.7573 17.318C15.6166 17.1774 15.5376 16.9866 15.5376 16.7877C15.5376 16.5888 15.6166 16.398 15.7573 16.2574C15.8979 16.1167 16.0887 16.0377 16.2876 16.0377C16.4865 16.0377 16.6773 16.1167 16.8179 16.2574L19.9999 19.4394L23.1819 16.2574C23.3225 16.1167 23.5133 16.0377 23.7122 16.0377C23.9111 16.0377 24.1019 16.1167 24.2425 16.2574Z",
    fill: "#C9EEF8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5c81b23e2656c98f395dba2fbcc6d80f.svg";
export { ForwardRef as ReactComponent };